<template>
  <div class="form-group" :class="{ 'has-error': errors.has(validationName) }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <v-date-picker
      is-dark
      mode="range"
      :input-props="{readonly: true}"
      :popover="{ placement: 'bottom', visibility: 'click' }"
      :value="value"
      :attributes="attributes"
      :first-day-of-week="1"
      :required="required"
      :data-vv-name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
    ></v-date-picker>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "form-group-date-range-picker",
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: {
      type: Object,
      default: () => {
        return {
          start: new Date(),
          end: new Date()
        }
      }
    }
  },
  data() {
    return {
      active: false,
      attributes: [
        {
          key: "today",
          dates: new Date(),
          highlight: {
            color: "purple",
            fillMode: "light"
          }
        }
      ]
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
      s;
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>

<style>
.vc-text-base {
  padding: 10.5px 10px 10.5px 10px !important;
  font-size: 14px !important;
  height: auto !important;
  box-shadow: none !important;
  border-radius: 3px !important;
  color: #555 !important;
  border: 1px solid #ccc !important;
  background-color: #fff !important;
}

.vc-text-base:focus {
  border-color: #999 !important;
  -moz-box-shadow: 3px 3px 0 rgba(12, 12, 12, 0.05) !important;
  -webkit-box-shadow: 3px 3px 0 rgba(12, 12, 12, 0.05) !important;
  box-shadow: 3px 3px 0 rgba(12, 12, 12, 0.05) !important;
}

.has-error .vc-reset input {
  border-color: #a94442 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupDateRangePicker.vue